<template>
  <router-view />
</template>

<style lang="scss">
@use '~@/styles/reset.scss';
</style>
